module.exports = __webpack_public_path__ + "img/fluentright.bae7595c.svg";